import React, { useEffect } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel, trackPageView } from './lib/pixel';
import { setPageMeta } from './lib/meta';
// Set title immediately — before React mounts — so the tab never shows "undefined"
document.title = 'El Método Hogar Dorado | Gana $500 Extra desde Casa';
function Root() {
  useEffect(() => {
    setPageMeta();
    initMetaPixel();
    trackPageView();
  }, []);
  return <App data-id="element-376" />;
}
render(<Root data-id="element-377" />, document.getElementById('root'));